import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
} from "@mui/material";
import { Logo } from "@rescuetablet/theme";
import { type ReactNode } from "react";
import { useAuth } from "./auth";

export default function Layout({ children }: { children: ReactNode }) {
  const { signOut } = useAuth();

  return (
    <>
      <AppBar color="secondary" position="static">
        <Toolbar>
          <Box sx={{ display: "flex", gap: 2, alignItems: "baseline" }}>
            <Box component={Logo} sx={{ height: [24, 32], width: "auto" }} />
            <Typography variant="h5" lineHeight={1}>
              Bürgertelefon
            </Typography>
          </Box>
          <Box sx={{ ml: "Auto" }}>
            <Button color="inherit" onClick={signOut}>
              Abmelden
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      <Container sx={{ py: 2 }}>{children}</Container>
    </>
  );
}
